module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QFbhAA/d2d_images/cover.jpg",
      "alt": "This image is the cover for the book La città del peccato"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("La città del peccato\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Mike è un uomo enigmatico che arriva a Las Vegas per godersi le sue sole 48 ore di ferie dell'anno. La fortuna sarà dalla sua parte e gli permetterà di vincere un grosso premio a una slot machine dell'hotel Bellagio e di incrociare la strada di Cristine, una donna che gli farà provare nuovi sentimenti. Riuscirà Mike a conquistare Cristine dopo che lei ha scoperto il grande segreto che lui nasconde sulla sua vera identità?"), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stefania Gil, Stefano Vazzola\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nacque a Caracas, Venezuela. Studiò Graphic Design e, dopo molti passi falsi, scoprì che la sua vera vocazione era scrivere. È un'autrice auto-pubblicata di romanzi rosa e di romanzi rosa paranormali. Adora leggere, e tutto ciò che è mistico e paranormale attira subito la sua attenzione. È immensamente curiosa di sapere cosa c'è al di là di ciò che si può vedere a prima vista, e forse è questo che l'ha portata a frequentare corsi di tarocchi, Wicca, Alta Magia e Reiki. Attualmente risiede nella città di Malaga con suo marito e una figlia piccola. E dal suo studio vista mare continua a scrivere per compiacere i suoi lettori."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24980248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0